import { EmailField, TextField, BooleanField, SimpleShowLayout, ShowProps } from "react-admin";

interface CustomerFieldsProps extends ShowProps {
  id?: string;
  [key: string]: any;
}

export const CustomerFields: React.FC<CustomerFieldsProps> = (props) => (
  <SimpleShowLayout {...props}>
    <EmailField source="email" label="Email"/>
    <TextField source="phone" label="Phone"/>
    <TextField source="first_name" label="First name"/>
    <TextField source="last_name" label="Last name"/>
    <TextField source="points" label="Puff points"/>
    <BooleanField source="active" label="Active Customer"/>
    <BooleanField source="ccpa_opt_out" label="CCPA Opt-Out"/>
    <TextField source="authentication_id" label="AuthO Id"/> 
  </SimpleShowLayout>        
);